export class LogoHelper {
  static companyLogoUrl(domainName) {
    return `https://company-logo.hunter.io/${domainName}`
  }
}
